import React from "react";
import { GetStaticProps } from "next";
import { serverSideMetaRequest } from "src/utils/helpers/requestApi/serverSideMetaRequest";
import { MetaDataPageType, SeoSchema } from "src/models/meta/getMetaData";
import MetaContainer from "src/components/common/Layout/components/MetaContainer/MetaContainer";
import FeedbackPage from "src/components/Feedback/FeedbackPage";

const FeedBack: React.FC<SeoSchema> = (props) => (
  <MetaContainer {...props}>
    <FeedbackPage />
  </MetaContainer>
);

export const getStaticProps: GetStaticProps = serverSideMetaRequest.bind(
  null,
  MetaDataPageType.feedback
);

export default FeedBack;
